module.exports = __webpack_public_path__ + "img/CBG.407d801b.png";